import { Cart } from "./cart";
import { Shopify } from "./shopify";

export function setupCheckoutButton() {
    const checkoutButton = document.getElementById("checkout-btn");

    if(!checkoutButton) {
        throw new Error("Could not find checkout button");
    }

    checkoutButton.addEventListener("click", async function() {
        const cartId = await Cart.getInstance().getOrCreateCart();
        const checkoutUrl = await getCheckoutUrl(cartId);
        window.location.href = checkoutUrl;
    });

    let checkoutBtnElement = checkoutButton as HTMLButtonElement;

    // Enable checkout button when checkbox is checked
    const termsCheckbox = document.getElementById("terms-checkbox") as HTMLInputElement;
    if(!termsCheckbox) {
        throw new Error("Could not find terms checkbox");
    }

    // Disable checkout button
    checkoutBtnElement.disabled = !termsCheckbox.checked;

    termsCheckbox.addEventListener("change", function() {
        checkoutBtnElement.disabled = !termsCheckbox.checked;
    });
}

export async function getCheckoutUrl(cartId: string) {
    const query = `
            query checkoutURL($id: ID!) {
                cart(id: $id) {
                    checkoutUrl
                }
            }`;
    
    const {data, errors, extensions} = await Shopify.getInstance().request(query, {
        variables: {
            id: cartId,
        },
    });

    if(!!errors) {
        console.error(errors);
        throw new Error("Could not get checkout URL");
    }

    return data.cart.checkoutUrl;
}